const BackButton = ({ hideButton }: { hideButton?: boolean }): JSX.Element => {
  return (
    <div className="ac-back-button--wrapper ch-mr--auto">
      {hideButton ||
      typeof window === 'undefined' ||
      !document.referrer.includes(window.origin) ? null : (
        <button
          className="ac-back-button ch-ba--0 ch-color--ac-black ch-bg--grey-2 ch-rounded--md ch-pv--1 ch-ph--2 ch-fs--3 ch-mt--3 sm:ch-mt--5 ch-mb--4"
          onClick={() => window.history.back()}
          type="button"
        >
          Back
        </button>
      )}
    </div>
  );
};

export default BackButton;
